import { render, staticRenderFns } from "./SunGraph.vue?vue&type=template&id=2b0aa0b6"
import script from "./SunGraph.vue?vue&type=script&lang=js"
export * from "./SunGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports